/**
 * Trash retention period in days
 * Playbooks deleted more than this many days ago will be permanently deleted
 */
export const TRASH_RETENTION_DAYS = 7
